module.exports = __webpack_public_path__ + "media/gra/gra001-b98babf3.svg";